import { Switch, Route, Redirect } from 'react-router-dom';
import React from 'react';
import loadRoute from 'launch/components/loadRoute';

const ProductLabelDesign = ({ match, location }) => (
    <Switch>
        <Route
            path={`${match.url}/designs`}
            component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), {
                withStyleAssessment: false,
            })}
        />
        <Route
            path={`${match.url}/attributes`}
            component={loadRoute(done => require(['launch/components/BriefStyleAttributes'], done))}
        />
        <Route
            path={`${match.url}/colors`}
            component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))}
        />
        <Route
            path={`${match.url}/brief`}
            component={loadRoute(done =>
                require(['launch/components/ProductLabelDesignBrief'], done)
            )}
        />
        <Redirect from="*" to={{ ...location, pathname: `${match.url}/designs` }} />
    </Switch>
);

export default ProductLabelDesign;



// WEBPACK FOOTER //
// ./js/launch/routes/ProductLabelDesign.jsx